import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { GeneralsettingServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};


const useGetSettingDataAlways = (onSuccess, onError = onDefaultError) => {
  return useQuery("general-setting-list", GeneralsettingServices.generalsettingList, {
    onSuccess,
    onError,
  });
};

const useStoreSettingData = (onSuccess, onError = onDefaultError) => {
    return useMutation(GeneralsettingServices.updateStatusGeneralsetting, {
      onSuccess,
      onError,
    });
  };
export {
    useGetSettingDataAlways,
    useStoreSettingData
 
};
